import { isNotBlankOrNullString } from './stringUtils';

export const getJwtToken = () => {
    return window.sessionStorage.getItem(process.env.REACT_APP_API_TOKEN_COOKIE_NAME);
};
export const setJwtToken = (token) => {
    if (isNotBlankOrNullString(token)) {
        window.sessionStorage.setItem(process.env.REACT_APP_API_TOKEN_COOKIE_NAME, token);
    } else {
        window.sessionStorage.removeItem(process.env.REACT_APP_API_TOKEN_COOKIE_NAME);
    }
};
export const deleteJwtToken = () => {
    window.sessionStorage.removeItem(process.env.REACT_APP_API_TOKEN_COOKIE_NAME);
};
export const jwtTokenExists = () => {
    return isNotBlankOrNullString(getJwtToken());
};

// Helper functions for JWT to decode it
export const decodeJWT = (token) => {
    const payload = token.split('.')[1];
    const base64Url = payload?.replace(/-/g, '+').replace(/_/g, '/');
    const base64 = base64Url?.padEnd(base64Url?.length + ((4 - (base64Url?.length % 4)) % 4), '=');

    // Decode the base64 string
    const binaryString = window.atob(base64);

    // Convert binary string to a byte array
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }

    return new TextDecoder('utf-8').decode(bytes);
};
